import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';

import Whychooseimg03 from '../../assets/images/pajji.png';

const Whychoosetwo = () => {
    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll(
                '.why-choose-two-image'
            );

            elements.forEach((el) => {
                const elementTop = el.getBoundingClientRect().top;
                const elementBottom = el.getBoundingClientRect().bottom;
                const viewportTop = 0;
                const viewportBottom = window.innerHeight;

                if (elementBottom > viewportTop && elementTop < viewportBottom) {
                    el.classList.add('active');
                }
            });
        };


        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });
   
    return (
        <div className="why-choose-two" style={{background: "#f2f4f8"}}>
            
            <div className="container">
                <div className="row gutter-y-30">
                    <div className="col-lg-7 align-self-center">
                        <div className="why-choose-right-two">
                            <div className="heading-box heading-white" style={{maxWidth: "40em"}}>
                            <h2 className="heading-title wow fadeInUp animated animated text-black" style={{marginTop: '0px', paddingTop: "0px", }}>
                                Our Vision
                                </h2>
                                <p style={{marginBottom: "10px"}}>To become the #1 trusted NRI advisory partner globally, known for unwavering transparency, cultural sensitivity, and smooth execution of complex matters.</p>
                                
                               
                            </div>
                            <h4 className="mt-4 mb-2">What we stand for</h4>
                            <p className="mb-3">At The NRI Advisors, our core values guide every action, case, and conversation:</p>
                            <ul className="vision-list vision">
                              <li><span className="text-muted"><strong >Regular Team Follow-Ups</strong> – We don’t wait to be chased.</span></li>
                              <li><span className="text-muted"><strong>Dedicated Case Management</strong> – One point of contact, always.</span></li>
                              <li><span className="text-muted"><strong>100% Transparency</strong> – No surprises, just clarity.</span></li>
                              <li><span className="text-muted"><strong>PAN-India Service</strong> – Wherever your case, we’re there.</span></li>
                              <li><span className="text-muted"><strong>Trust & Capability</strong> – Our word is our bond.</span></li>
                              <li><span className="text-muted"><strong>Result-Oriented Approach</strong> – We measure success by solutions.</span></li>
                              <li><span className="text-muted"><strong>Confidentiality & Professionalism</strong> – Always secure. Always respectful.</span></li>
                            </ul>
                           
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="why-choose-two-image">
                            <img
                                src={Whychooseimg03} alt="why-choose-image"
                            />
                            <div className="image-shape">
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 mt-5">
                        <div className="row gutter-y-30">
                            {whychoosedata.map((data, index) =>
                                <div key={index}
                                    className="col-lg-4" >
                                    <div className="why-choose-two-box">
                                        <i className="flaticon-transparency" />
                                        <div className="why-choose-two-box-info">
                                            <h4>{data.heading}</h4>
                                            <p>
                                                {data.about}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> */}
                </div>
            </div>
        </div >


    )
}
export default Whychoosetwo;